import React from 'react'
import useTabs from 'pages/NewDashboard/hooks/useTabs'
import { VerticalHeaderStyles } from './styles'
import TabsContainer from './TabsContainer'
import ReportTab from './ReportTab'

const VerticalHeader = () => {
  const classes = VerticalHeaderStyles()
  const { topTabs, bottomTabs } = useTabs()
  return (
    <div className={classes.container}>
      {/* Report sits with the top group so space-between keeps Help/Settings pinned below */}
      <div className={classes.topGroup}>
        <TabsContainer tabs={topTabs} />
        <ReportTab />
      </div>
      <TabsContainer tabs={bottomTabs} />
    </div>
  )
}

export default VerticalHeader
